import isComponentType from './is-component-type';
import Stepper from '../components/stepper';
export default function searchChildrenForStepper(children) {
  if (!Array.isArray(children)) {
    return 0;
  }

  return children.reduce(function (memo, current) {
    var _current$props, _current$props$childr;

    if (isComponentType(current, Stepper.name)) {
      var values = current.props.values;
      memo += Array.isArray(values) ? values.length : 0;
    } else if ((current === null || current === void 0 ? void 0 : (_current$props = current.props) === null || _current$props === void 0 ? void 0 : (_current$props$childr = _current$props.children) === null || _current$props$childr === void 0 ? void 0 : _current$props$childr.length) > 0) {
      memo += searchChildrenForStepper(current.props.children);
    }

    return memo;
  }, 0);
}